import { Skeleton } from '@mantine/core';

export default function PageListSkeleton() {
  return (
    <>
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
      <Skeleton height={25} my="xs" radius="xs" />
    </>
  );
}
